
import React, { useEffect } from 'react';

const UnloadWarning = () => {
  useEffect(() => {
    const handleUnload = (event) => {
      const authToken = window.localStorage.getItem('authToken');
      if (authToken) {
        event.preventDefault();
        event.returnValue = 'Are you sure you want to leave? Your unsaved changes may be lost.';
      }

    };

    window.addEventListener('beforeunload', handleUnload);
    return () => {
      window.removeEventListener('beforeunload', handleUnload);
    };
  }, []);

  return null;
};

export default UnloadWarning;